import React, { useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Modal, { ModalButton } from '../../../ui/Modal';

const ApplicationsModalConfirm = ({ onClose, onConfirm, getWeekNumber }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [weekNumber, setWeekNumber] = useState(null);
  const [touched, setTouched] = useState(false);

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    setTouched(true);
    if (date) setWeekNumber(getWeekNumber(date));
    else setWeekNumber(null);
  };

  const handleConfirm = () => {
    if (!weekNumber) {
      setTouched(true);
      return;
    }
    onConfirm(weekNumber);
    onClose();
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Подтвердить заявки"
      subtitle="Выберите дату — она используется для расчёта номера недели"
      size="sm"
      footer={
        <>
          <ModalButton variant="ghost" onClick={onClose}>Отмена</ModalButton>
          <ModalButton variant="primary" onClick={handleConfirm} disabled={!weekNumber}>
            <CheckCircleOutlineIcon sx={{ fontSize: 18 }} />
            Подтвердить
          </ModalButton>
        </>
      }
    >
      <div className="uimodal-field" style={{ gridTemplateColumns: '1fr', padding: 0 }}>
        <label className="uimodal-field__label" htmlFor="confirm-date">
          Дата (для расчёта недели)
        </label>
        <input
          id="confirm-date"
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          style={{
            width: '100%', height: 40, padding: '0 12px',
            border: `1px solid ${touched && !weekNumber ? '#DC4D45' : 'rgba(56,47,42,0.18)'}`,
            borderRadius: 8, fontFamily: 'inherit', fontSize: 13.5, color: '#1F1A17',
            background: '#fff', outline: 'none',
            transition: 'border-color 140ms ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#F08F5A'}
          onBlur={(e) => {
            e.target.style.borderColor =
              touched && !weekNumber ? '#DC4D45' : 'rgba(56,47,42,0.18)';
          }}
        />
      </div>

      {weekNumber && (
        <div style={{
          marginTop: 12, padding: '10px 12px',
          background: 'rgba(74, 165, 135, 0.10)',
          border: '1px solid rgba(74, 165, 135, 0.25)',
          color: '#0F5B3C', borderRadius: 8,
          display: 'flex', justifyContent: 'space-between',
          fontSize: 13, fontWeight: 500,
        }}>
          <span>Номер недели</span>
          <strong>{weekNumber}</strong>
        </div>
      )}

      {touched && !weekNumber && (
        <div style={{
          marginTop: 12, padding: '10px 12px',
          background: 'rgba(220, 77, 69, 0.08)',
          border: '1px solid rgba(220, 77, 69, 0.25)',
          color: '#B73C36', borderRadius: 8, fontSize: 13,
        }}>Сначала выберите дату.</div>
      )}
    </Modal>
  );
};

export default ApplicationsModalConfirm;
